/** @format */

import React, { Fragment } from 'react';
import { render } from 'react-dom';
import './analytics';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/lib/integration/react';

import { Provider } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { history, store, persistor } from './store/configureStore';
import Notifications from 'src/utils/Notifications';
import I18N from './i18n';
import routes from 'src/routes';
import theme from 'src/ui/library/theme';
import 'src/scss/index.scss';
import { v4 as uuidv4 } from 'uuid';
import { Helmet } from "react-helmet";
const nonce = uuidv4() && uuidv4().toString('base64');
const csp = `
default-src 'self';
script-src 'self' g.alicdn.com az416426.vo.msecnd.net 'strict-dynamic' 'nonce-${nonce}';
style-src 'self' 'nonce-${nonce}';
img-src 'self' data: *;
connect-src 'self' dc.services.visualstudio.com *.ey.com dpm.demdex.net api.ipify.org;
frame-src *.powerbi.com;
`;
window.__webpack_nonce__= nonce;

// attempt at addressing cache issue
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}
class App extends React.Component {
  render() {
    return (
      <Fragment>
        <Helmet>
            <meta http-equiv="Content-Security-Policy" content={csp} />
            <meta property="csp-nonce" content={nonce} />
        </Helmet>
        <Provider store={store}>
          <PersistGate
            loading={() => {
              return <h1>loading</h1>;
            }}
            persistor={persistor}>
            <MuiThemeProvider theme={theme()}>
              <I18N>
                <Notifications>
                  <ConnectedRouter history={history}>{routes}</ConnectedRouter>
                </Notifications>
              </I18N>
            </MuiThemeProvider>
          </PersistGate>
        </Provider>
      </Fragment>
    );
  }
}

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js